import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import {
  KcDataService
} from '../../../kc-data.service'
import { InstantErrorStateMatcherService } from '../../../services/instant-error-state-matcher.service'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { KcRequestBusinessInvite } from '../../../interfaces/kc-data.interface'
@Component({
  selector: 'customer-portal-app-revolution-request-business-invite',
  templateUrl: './revolution-request-business-invite.component.html'
})
export class RevolutionRequestBusinessInviteComponent implements OnInit {
  matcher = new InstantErrorStateMatcherService()

  companyNameRegex: string
  companyVehiclesRegex: string
  addressZipRegex: string
  addressCityRegex: string
  emailRegex: string

  constructor(
    private readonly kcDataService: KcDataService,
    public transifexService: TransifexService,
    public remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.companyNameRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.companyName.pattern'
    )
    this.companyVehiclesRegex = this.remoteConfigService.get(
      'regEx.companyRegEx.vehicles.pattern'
    )
    this.addressZipRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.zip.pattern'
    )
    this.addressCityRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.city.pattern'
    )
    this.emailRegex = this.remoteConfigService.get('regEx.emailRegEx.pattern')

    this.form = new FormGroup({
      email: new FormControl<string | null>(null, [
        Validators.maxLength(50),
        Validators.pattern(this.emailRegex)
      ]),
      companyName: new FormControl<string | null>(
        null,
        Validators.pattern(this.companyNameRegex)
      ),
      zip: new FormControl<string | null>(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.addressZipRegex),
          Validators.minLength(
            this.remoteConfigService.get('regEx.addressRegEx.zip.minLength')
          ),
          Validators.maxLength(
            this.remoteConfigService.get('regEx.addressRegEx.zip.maxLength')
          )
        ])
      ),
      city: new FormControl<string | null>(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.addressCityRegex),
          Validators.maxLength(
            this.remoteConfigService.get('regEx.addressRegEx.city.maxLength')
          )
        ])
      ),
      numberOfVehicles: new FormControl<string | null>(
        null,
        Validators.pattern(this.companyVehiclesRegex)
      )
    })
  }

  @ViewChild('requestBusinessInviteForm', { static: true })
  private readonly formRef: ElementRef

  public viewData: KcRequestBusinessInvite
  public submitting: boolean

  public form
  ngOnInit(): void {
    this.viewData = this.kcDataService.getViewData() as KcRequestBusinessInvite
  }

  public register() {
    this.submitting = true

    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  back() {
    window.history.back()
  }
}
